import parameters, { parameterCodes } from 'data/parameters'

const defaultState = {
  items: []
}

function getModifyEffect([ popularityEffect, profitabilityEffect ], parameter) {
  if (parameter.code === parameterCodes.popularity) return  {
    score: parameter.score + popularityEffect,
    dynamic: popularityEffect,
  }

  if (parameter.code === parameterCodes.profitability) return  {
    score: parameter.score + profitabilityEffect,
    dynamic: profitabilityEffect,
  }

  return {
    score: parameter.score,
    dynamic: parameter.dynamic,
  }
}

export default {
  namespace: 'score',
  state: defaultState,
  subscriptions: {
    setup({ dispatch }) {
      const score = parameters.map(p => Object.assign({}, p, {
        dynamic: 0
      }))

      dispatch({ type: 'setItems', payload: score })
    },
  },
  reducers: {
    setItems(state, { payload }) {
      return Object.assign({}, state, {
        items: payload.slice()
      })
    },
    modify(state, { payload }) {
      return Object.assign({}, state, {
        items: state.items.map(parameter => {
          const modifyEffect = getModifyEffect(payload, parameter)

          return Object.assign({}, parameter, modifyEffect)
        })
      })
    },
    reset() {
      const score = parameters.map(p => Object.assign({}, p, {
        dynamic: 0
      }))

      return Object.assign({}, defaultState, {
        items: score.slice()
      })
    }
  },
}



// WEBPACK FOOTER //
// ./src/models/score/index.js